// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__3S90a","loader":"ContentLoader_loader__2f2jT","disabled":"ContentLoader_disabled__15pFc"};